var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"indicator-message",class:{highlight: _vm.isHighlighted, hover: hover},attrs:{"id":"tour-follow-camera-track"},on:{"click":_vm.switchMode}},[_vm._v(" "+_vm._s(_vm.message)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }